<div *ngIf="!isLoading">
    <div style="margin-left: 80%; margin-bottom: 2%;">
        <button id="print-button" class="noPrint" style="margin-top: 2%; margin-left: 2%; display: none; "
            mat-raised-button color="primary" printSectionId="print-section" [useExistingCss]="true" ngxPrint>
            Print
        </button>

        <button (click)="print()" class="noPrint" style="margin-top: 2%; margin-left: 2%" mat-raised-button
            color="primary">
            Print
        </button>
        <button class="noPrint" style="margin-top: 2%; margin-left: 2%" (click)="exportExcel('Issue_Invoice_Register')"
            mat-raised-button color="primary">
            Export
        </button>
        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>
    </div>
    <ng-container *ngIf="reportType == 'In Detail'">
        <div class="container" id="print-section">

            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th colspan="13">हिंदुस्थान प्रकाशन संस्था - विवेक साप्ताहिक - अंक/ग्रंथ विक्री विभाग- Issue
                            Seller
                            Invoice
                            Register
                        </th>
                        <th colspan="2">In Detail</th>
                        <th colspan="5">दिनांक - {{ today | date:"dd-MM-yyy" }}</th>
                        <th colspan="4">पृष्ठ क्र. -</th>
                    </tr>
                    <tr>
                        <th></th>
                        <th colspan="7" class="leftAlign">
                            <!-- <div>Issue Name : {{ issueName }}</div> -->
                        </th>
                        <th colspan="6" class="leftAlign">
                            <div>Issue Date :</div>
                        </th>
                        <th colspan="8" class="leftAlign">
                            <div>Date : From : {{ startDate | date:"dd-MM-yyy" }} To : {{ endDate | date:"dd-MM-yyy" }}
                            </div>
                        </th>
                    </tr>
                    <tr>
                        <th rowspan="2" style="font-size: 14px !important; text-align: center;">Invoice No.</th>
                        <th rowspan="2" style="font-size: 14px !important; text-align: center;">Invoice Date</th>
                        <th rowspan="2" style="font-size: 14px !important; text-align: center;">Issue Seller Name</th>
                        <!-- <th rowspan="2" style="font-size: 14px !important; text-align: center;">Customer <br>  Name</th> -->
                        <th rowspan="2" style="font-size: 14px !important; text-align: center;">Issue Name</th>
                        <th rowspan="2" style="font-size: 14px !important; text-align: center;">Issue Date</th>
                        <th rowspan="2" style="font-size: 14px !important; text-align: center;">Representative <br> Name
                        </th>
                        <th rowspan="2" style="font-size: 14px !important; text-align: center;">Office <br>
                            Representative <br> Name</th>
                        <th colspan="5" style="font-size: 14px !important; text-align: center;">Weekly Issue <br> Date
                        </th>
                        <th rowspan="2" style="font-size: 14px !important; text-align: center;">issue . <br> Amount</th>
                        <th rowspan="2" style="font-size: 14px !important; text-align: center;">Discount <br>Amount</th>
                        <th rowspan="2" style="font-size: 14px !important; text-align: center;">Amount before GST</th>
                        <th rowspan="2" style="font-size: 14px !important; text-align: center;">CGST</th>
                        <th rowspan="2" style="font-size: 14px !important; text-align: center;">SGST</th>
                        <th rowspan="2" style="font-size: 14px !important; text-align: center;">IGST</th>
                        <th rowspan="2" style="font-size: 14px !important; text-align: center;">Total Invoice <br>
                            Amount</th>
                        <th rowspan="2" style="font-size: 14px !important; text-align: center;">Paid <br> Amount</th>
                        <th rowspan="2" style="font-size: 14px !important; text-align: center;">Unpaid <br> Amount</th>
                    </tr>
                    <tr>
                        <th>1st Week</th>
                        <th>2nd Week</th>
                        <th>3rd Week</th>
                        <th>4th Week</th>
                        <th>5th Week</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let data of filteredAdvtInvoiceData; ">
                        <ng-container *ngIf="!end">
                            <ng-container>
                                <tr>
                                    <td style="text-align: end;">{{ data['invoice_no'] }}</td>
                                    <td style="text-align: end;">{{ data['invoice_date'] }}</td>
                                    <td style="text-align: end;">{{ data['issue_seller_name'] }}</td>
                                    <!-- <td style="text-align: start;">{{ data['cust_name'] }}</td> -->
                                    <td style="text-align: end;">{{ data['issue_name'] }}</td>
                                    <td style="text-align: end;"> {{ data['issue_date'] }}</td>
                                    <td style="text-align: end;">{{ data['representative_id'] }}</td>
                                    <td style="text-align: end;">{{ data['office_representation_id'] }}</td>

                                    <!-- <td>{{ data['firstweek_issue_date'] }}</td> -->
                                    <td style="text-align: end;"><ng-container
                                            *ngIf="data['first_week'] != '0'; else week1">{{ data['first_week_amount'] |
                                            number: '1.2-2' }}</ng-container>
                                        <ng-template #week1>0</ng-template>
                                    </td>
                                    <td style="text-align: end;"><ng-container
                                            *ngIf="data['second_week'] != '0'; else week2">{{
                                            data['second_week_amount']| number: '1.2-2' }} </ng-container>
                                        <ng-template #week2>0</ng-template>
                                    </td>
                                    <td style="text-align: end;"><ng-container
                                            *ngIf="data['third_week'] != '0'; else week3">{{ data['third_week_amount'] |
                                            number: '1.2-2' }}</ng-container>
                                        <ng-template #week3>0</ng-template>
                                    </td>
                                    <td style="text-align: end;"><ng-container
                                            *ngIf="data['fourth_week'] != '0'; else week4">{{ data['fourth_week_amount']
                                            | number: '1.2-2' }}</ng-container>
                                        <ng-template #week4>0</ng-template>
                                    </td>
                                    <td style="text-align: end;"><ng-container
                                            *ngIf="data['fifth_week'] != '0'; else week5">{{ data['fifth_week_amount'] |
                                            number: '1.2-2'}} </ng-container>
                                        <ng-template #week5>0</ng-template>
                                    </td>


                                    <td style="text-align: end;"><span>{{ data['issue_selling_amount'] | number: '1.2-2'
                                            }}</span></td>
                                    <td style="text-align: end;"><span>{{ data['issue_selling_discount_amt']| number:
                                            '1.2-2' }}</span></td>
                                    <td style="text-align: end;"><span>{{ data['net_amount'] | number: '1.2-2'}}</span>
                                    </td>

                                    <td style="text-align: end;">
                                        <span>
                                            {{
                                            (+data['first_week_cgst'] || 0) +
                                            (+data['second_week_cgst'] || 0) +
                                            (+data['third_week_cgst'] || 0) +
                                            (+data['fourth_week_cgst'] || 0) +
                                            (+data['fifth_week_cgst'] || 0)
                                            | number: '1.2-2'}}
                                        </span>
                                    </td>

                                    <!-- SGST Total -->
                                    <td style="text-align: end;">
                                        <span>
                                            {{
                                            (+data['first_week_sgst'] || 0) +
                                            (+data['second_week_sgst'] || 0) +
                                            (+data['third_week_sgst'] || 0) +
                                            (+data['fourth_week_sgst'] || 0) +
                                            (+data['fifth_week_sgst'] || 0)
                                            | number: '1.2-2'}}
                                        </span>
                                    </td>

                                    <!-- IGST Total -->
                                    <td style="text-align: end;">
                                        <span>
                                            {{
                                            (+data['first_week_igst'] || 0) +
                                            (+data['second_week_igst'] || 0) +
                                            (+data['third_week_igst'] || 0) +
                                            (+data['fourth_week_igst'] || 0) +
                                            (+data['fifth_week_igst'] || 0)
                                            | number: '1.2-2'}}
                                        </span>
                                    </td>
                                    <td style="text-align: end;"><span>{{ data['pay_amt']| number: '1.2-2' }}</span>
                                    </td>
                                    <td style="text-align: end;"><span>{{ data['received_amt']||0 | number: '1.2-2'
                                            }}</span></td>
                                    <td style="text-align: end;">
                                        <span>
                                            {{
                                            (+data['net_amount'] || 0) +
                                            (+data['gst_amount'] || 0) -
                                            (+data['received_amt'] || 0)
                                            | number: '1.2-2'}}
                                        </span>
                                    </td>


                                </tr>

                            </ng-container>
                        </ng-container>

                    </ng-container>
                </tbody>

                <tr style="background-color: #e8f0ff; font-weight: bold;">
                    <td style="font-weight: bold;  border-bottom: 1px solid #000; border-right: 1px solid #000; border-left: 1px solid #000;"
                        class="right">Total</td>
                    <td colspan="6"></td>
                    <td style="text-align: end;">{{ firstweek | number: '1.2-2' }}</td>
                    <td style="text-align: end;">{{ secondweek | number: '1.2-2' }}</td>
                    <td style="text-align: end;">{{ thirdweek | number: '1.2-2' }}</td>
                    <td style="text-align: end;">{{ fourthweek | number: '1.2-2' }}</td>
                    <td style="text-align: end;">{{ fifthweek | number: '1.2-2' }}</td>
                    <td style="text-align: end;">{{ issueamt | number: '1.2-2' }}</td>
                    <td style="text-align: end;">{{ discountamt3 | number: '1.2-2' }}</td>
                    <td style="text-align: end;">{{ beforegst11 | number: '1.2-2' }}</td>
                    <td style="text-align: end;">{{ cgst4 | number: '1.2-2' }}</td>
                    <td style="text-align: end;">{{ sgst4| number: '1.2-2' }}</td>
                    <td style="text-align: end;">{{ igst4 | number: '1.2-2' }}</td>
                    <td style="text-align: end;">{{ advtamount | number: '1.2-2' }}</td>
                    <td style="text-align: end;">{{ paidamount1 | number: '1.2-2'}}</td>
                    <td style="text-align: end;">{{ advtamount - paidamount1 | number: '1.2-2' }}</td>

                </tr>

            </table>
        </div>
    </ng-container>

    <ng-container *ngIf="reportType == 'Briefly'">
        <div class="container mt-4" id="print-section">
            <table class="table table-bordered table-sm"
                style="width: 100%; border-collapse: collapse; font-size: 14px;">

                <tr>
                    <th colspan="12" style="text-align: left; padding: 8px;">
                        हिंदुस्थान प्रकाशन संस्था - विवेक साप्ताहिक - अंक/ग्रंथ विक्री विभाग
                    </th>
                    <th colspan="2" style="text-align: right; padding: 8px;">दिनांक - {{ today | date:"dd-MM-yyyy" }}
                    </th>
                    <th colspan="2" style="text-align: right; padding: 8px;">पृष्ठ क्र. -</th>
                </tr>
                <tr>
                    <th colspan="4" style="text-align: left;">Issue Invoice Register</th>
                    <th colspan="3" style="text-align: left;">Briefly</th>
                    <th colspan="3" style="text-align: left;">Date</th>
                    <th colspan="3" style="text-align: left;">From: {{ startDate | date:"dd-MM-yyyy" }}</th>
                    <th colspan="3" style="text-align: left;">To: {{ endDate | date:"dd-MM-yyyy" }}</th>
                </tr>
                <tr>
                    <th>Invoice No.</th>
                    <th>Invoice Date</th>
                    <th>Issue Seller Name</th>
                    <th>Issue Name</th>
                    <th>Issue Date</th>
                    <th class="text-end">Amount</th>
                    <th class="text-end">Discount Amount</th>
                    <th class="text-end">Amount Before GST</th>
                    <th class="text-end">CGST</th>
                    <th class="text-end">SGST</th>
                    <th class="text-end">IGST</th>
                    <th class="text-end">Total GST</th>
                    <th class="text-end">Total Invoice Amount</th>
                    <th class="text-end">Paid Amount</th>
                    <th class="text-end">Unpaid Amount</th>
                </tr>

                <tbody>
                    <ng-container *ngFor="let data of filteredAdvtInvoiceDatabrifly; let i = index">
                        <tr>
                            <td>{{ data['invoice_no'] }}</td>
                            <td>{{ data['invoice_date'] }}</td>
                            <td>{{ data['issue_seller_name'] }}</td>
                            <td>{{ data['issue_name'] }}</td>
                            <td>{{ data['issue_date'] }}</td>
                            <td class="text-end">{{ data['amount'] | number: '1.2-2' }}</td>
                            <td class="text-end">{{ data['discount'] | number: '1.2-2' }}</td>
                            <td class="text-end">{{ data['beforegst_amt'] | number: '1.2-2' }}</td>
                            <td class="text-end">{{ data['cgst'] | number: '1.2-2' }}</td>
                            <td class="text-end">{{ data['sgst'] | number: '1.2-2' }}</td>
                            <td class="text-end">{{ data['igst'] | number: '1.2-2' }}</td>
                            <td class="text-end">{{ data['gst'] | number: '1.2-2' }}</td>
                            <td class="text-end">{{ data['issue_amt'] | number: '1.2-2' }}</td>
                            <td class="text-end">{{ (data.received_amt || 0) | number: '1.2-2' }}</td>
                            <td class="text-end">{{ data.pending_amt | number: '1.2-2' }}</td>
                        </tr>
                    </ng-container>
                </tbody>

                <tr style="font-weight: bold;background-color: #e8f0ff; font-weight: bold;">
                    <td>Totals</td>
                    <td colspan="4"></td>
                    <td class="text-end">{{ totalamount | number: '1.2-2' }}</td>
                    <td class="text-end">{{ discountamt | number: '1.2-2' }}</td>
                    <td class="text-end">{{ beforegst | number: '1.2-2' }}</td>
                    <td class="text-end">{{ tcgst | number: '1.2-2' }}</td>
                    <td class="text-end">{{ tsgst | number: '1.2-2' }}</td>
                    <td class="text-end">{{ tigst | number: '1.2-2' }}</td>
                    <td class="text-end">{{ tgst | number: '1.2-2' }}</td>
                    <td class="text-end">{{ totalamount2 | number: '1.2-2' }}</td>
                    <td class="text-end">{{ receivedamt | number: '1.2-2' }}</td>
                    <td class="text-end">{{ totalamount2 - receivedamt | number: '1.2-2' }}</td>
                </tr>

            </table>
        </div>
    </ng-container>

    <ng-container *ngIf="reportType == 'Monthwise'">
        <div class="container" id="print-section">
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th colspan="8">हिंदुस्थान प्रकाशन संस्था - विवेक साप्ताहिक - जाहिरात विभाग
                        </th>
                        <th colspan="2">दिनांक - {{ today | date:"dd-MM-yyy" }}</th>
                        <th colspan="2">पृष्ठ क्र. -</th>
                    </tr>
                    <tr>
                        <th colspan="4"> Issue Seller Invoice Register</th>
                        <th colspan="2">Monthwise</th>
                        <th colspan="2">Date</th>
                        <th colspan="2">From :- {{ startDate | date:"dd-MM-yyy" }} </th>
                        <th colspan="2">To :- {{ endDate | date:"dd-MM-yyy" }} </th>
                    </tr>

                    <tr>
                        <th>Invoice Month</th>
                        <th>issue seller. Amount</th>
                        <th>Discount Amount</th>
                        <th>Net Amount</th>
                        <th>Amount Before GST</th>
                        <th>CGST</th>
                        <th>SGST</th>
                        <th>IGST</th>
                        <th>Total GST</th>
                        <th>Total Invoice Amount</th>
                        <th>Paid Amount</th>
                        <th>Unpaid Amount</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let data of filteredAdvtInvoiceDatamonthly; let i = index">
                        <tr>
                            <td class="right text-end">{{ data.month }}-{{ data.year }}</td>

                            <td class="right text-end" style="text-align: end;">{{ data['issue_amt'] | number: '1.2-2'
                                }}</td>
                            <td class="right text-end" style="text-align: end;">{{ data['discount'] | number: '1.2-2' }}
                            </td>
                            <td class="right text-end" style="text-align: end;">{{ data['net_amount'] | number: '1.2-2'
                                }}</td>
                            <td class="right text-end" style="text-align: end;">{{ data['beforegst_amt'] | number:
                                '1.2-2' }}</td>
                            <td class="right text-end" style="text-align: end;">{{ data['cgst'] | number: '1.2-2'}}</td>
                            <td class="right text-end" style="text-align: end;">{{ data['sgst'] | number: '1.2-2'}}</td>
                            <td class="right text-end" style="text-align: end;">{{ data['igst'] | number: '1.2-2'}}</td>
                            <td class="right text-end" style="text-align: end;">{{ data['gst'] | number: '1.2-2' }}</td>
                            <td class="right text-end" style="text-align: end;">{{ data['amount'] | number: '1.2-2'}}
                            </td>
                            <td class="right text-end" style="text-align: end;">{{ data['received_amt'] | number:
                                '1.2-2'}}</td>
                            <td class="right text-end" style="text-align: end;">{{ (data['amount'] || 0) -
                                (data['received_amt'] || 0) | number: '1.2-2' }}</td>
                        </tr>
                    </ng-container>

                </tbody>

                <tr style="background-color: #e8f0ff; font-weight: bold;">

                    <td>Totals</td>
                    <td class="text-end" style="text-align: end;">{{ totalamount1 }}</td>
                    <td class="text-end" style="text-align: end;">{{ discountamt1 }}</td>
                    <td class="text-end" style="text-align: end;">{{ netamount1 }}</td>
                    <td class="text-end" style="text-align: end;">{{ beforegst1 }}</td>
                    <td class="text-end" style="text-align: end;">{{ tcgst1 | number: '1.2-2' }}</td>
                    <td class="text-end" style="text-align: end;">{{ tsgst1 | number: '1.2-2' }}</td>
                    <td class="text-end" style="text-align: end;">{{ tigst1 | number: '1.2-2' }}</td>
                    <td class="text-end" style="text-align: end;">{{ tgst1 | number: '1.2-2' }}</td>
                    <td class="text-end" style="text-align: end;">{{ amount1 | number: '1.2-2' }}</td>
                    <td class="text-end" style="text-align: end;">{{ receivedamt1 }}</td>
                    <td class="text-end" style="text-align: end;">{{ amount1 - receivedamt1 }}</td>
                </tr>

            </table>
        </div>
    </ng-container>
<ng-container *ngIf="reportType == 'rnireport'">
  <div class="container mt-4" id="print-section">
    <table class="table table-bordered table-sm" style="width:100%; border-collapse: collapse; font-size:14px;">

      <!-- Report Header -->
      <tr style="background-color:#f9f9f9;">
        <th colspan="3" style="text-align:center; font-size:16px; font-weight:bold; padding:8px;">
          हिंदुस्थान प्रकाशन संस्था - विवेक साप्ताहिक
        </th>
        <th colspan="3" style="text-align:center; font-size:15px; font-weight:bold; padding:8px;">
          अंक / ग्रंथ विक्री विभाग
        </th>
        <th colspan="4" style="text-align:center; font-size:14px; font-weight:bold; padding:8px;">
          Issue Seller RNI अहवाल (Month Wise)
        </th>
        <th colspan="2" style="text-align:left; padding:8px;">
          दिनांक : {{ today | date:"dd-MM-yyyy" }}
        </th>
        <th colspan="3" style="text-align:left; padding:8px;">
          कालावधी : {{ startDate | date:"dd-MM-yyyy" }} ते <br>{{ endDate | date:"dd-MM-yyyy" }}
        </th>
      </tr>

      <!-- Column Headers -->
      <tr style="background-color:#f0f4ff; font-weight:bold; text-align:center;">
        <th rowspan="2">महिना</th>
        <th rowspan="2">देय्यक क्रमांक</th>
        <th rowspan="2">देय्यक दिनांक</th>
        <th rowspan="2">अभिकर्त्याचे नाव </th>
        <th colspan="5">आठवडे व प्रकाशन दिनांक </th>
        <th rowspan="2">एकूण प्रती</th>
        <th rowspan="2">एकूण रक्कम </th>
        <th rowspan="2">एकूण सूट रक्कम </th>
        <th rowspan="2">देय्यक रक्कम </th>
        <th rowspan="2">मागील बाकी रु </th>
        <th rowspan="2">येणे बाकी रक्कम</th>
      </tr>

      <tr style="background-color:#f0f4ff; font-weight:bold; text-align:center;">
        <th>1st Week</th>
        <th>2nd Week</th>
        <th>3rd Week</th>
        <th>4th Week</th>
        <th>5th Week</th>
      </tr>

      <!-- Data Rows -->
      <ng-container *ngFor="let month of monthWiseRNIData">
        <tr style="font-weight:bold; background-color:#e8f0ff;">
          <td colspan="15">{{ month.monthName }}</td>
        </tr>

        <ng-container *ngFor="let data of month.invoices">
          <tr>
            <td></td>
            <td>{{ data.invoice_no }}</td>
            <td>{{ data.invoice_date | date:'dd-MM-yyyy' }}</td>
            <td>{{ data.issue_seller_name }}{{ data.taluka ? ' - ' + data.taluka : '' }}</td>
            <td class="text-end">{{ +data.week1_copies || 0 }}</td>
            <td class="text-end">{{ +data.week2_copies || 0 }}</td>
            <td class="text-end">{{ +data.week3_copies || 0 }}</td>
            <td class="text-end">{{ +data.week4_copies || 0 }}</td>
            <td class="text-end">{{ +data.week5_copies || 0 }}</td>

            <td class="text-end">{{ +data.total_week_copies || 0 }}</td>
            <td class="text-end">{{ +data.total_amount | number:'1.2-2' }}</td>
            <td class="text-end">{{ +data.total_discount || 0 }}</td>
            <td class="text-end">{{ (+data.total_amount - +data.total_discount) | number:'1.2-2' }}</td>
            <td class="text-end">{{ +data.opening_bal | number:'1.2-2' }}</td>
            <td class="text-end">{{ (+data.opening_bal + (+data.total_amount - +data.total_discount)) | number:'1.2-2' }}</td>
          </tr>
        </ng-container>

        <!-- Month Totals -->
        <tr style="font-weight:bold; background-color:#f9f9f9;">
          <td colspan="4" style="text-align:right;">महिन्याची एकूण :-विक्री प्रति({{ month.monthName }} )</td>
          <td class="text-end">{{ month.totalW1 | number:'1.0-0' }}</td>
          <td class="text-end">{{ month.totalW2 | number:'1.0-0' }}</td>
          <td class="text-end">{{ month.totalW3 | number:'1.0-0' }}</td>
          <td class="text-end">{{ month.totalW4 | number:'1.0-0' }}</td>
          <td class="text-end">{{ month.totalW5 | number:'1.0-0' }}</td>
          <td class="text-end">{{ month.totalCopies | number:'1.0-0' }}</td>
          <td class="text-end">{{ month.totalAmt | number:'1.2-2' }}</td>
          <td class="text-end">{{ month.totalDisc | number:'1.0-0' }}</td>
          <td class="text-end">{{ (month.totalAmt - month.totalDisc) | number:'1.2-2' }}</td>
          <td class="text-end">{{ month.totalOpening | number:'1.2-2' }}</td>
          <td class="text-end">{{ month.totalOpening + (month.totalAmt - month.totalDisc) | number:'1.2-2' }}</td>
        </tr>

        <!-- Month Complimentary Totals -->
        <tr style="font-weight:bold; background-color:white;">
          <td colspan="4" style="text-align:right;">महिन्याची एकूण:-सप्रेम-भेट-प्रति ({{ month.monthName }})</td>
          <td class="text-end">{{ month.totalCW1 || 0 }}</td>
          <td class="text-end">{{ month.totalCW2 || 0 }}</td>
          <td class="text-end">{{ month.totalCW3 || 0 }}</td>
          <td class="text-end">{{ month.totalCW4 || 0 }}</td>
          <td class="text-end">{{ month.totalCW5 || 0 }}</td>
          <td class="text-end">{{ month.totalCCopies || 0 }}</td>
          <td class="text-end"></td>
          <td class="text-end"></td>
          <td class="text-end"></td>
          <td class="text-end"></td>
          <td class="text-end"></td>
        </tr>

      </ng-container>

      <!-- Grand Totals -->
      <tr style="font-weight:bold; background-color:#dbe9ff;">
        <td colspan="4" style="text-align:right;">एकूण :-विक्री प्रति</td>
        <td class="text-end">{{ grandW1 | number:'1.0-0' }}</td>
        <td class="text-end">{{ grandW2 | number:'1.0-0' }}</td>
        <td class="text-end">{{ grandW3 | number:'1.0-0' }}</td>
        <td class="text-end">{{ grandW4 | number:'1.0-0' }}</td>
        <td class="text-end">{{ grandW5 | number:'1.0-0' }}</td>
        <td class="text-end">{{ grandCopies | number:'1.0-0' }}</td>
        <td class="text-end">{{ grandAmt | number:'1.2-2' }}</td>
        <td class="text-end">{{ grandDisc | number:'1.0-0' }}</td>
        <td class="text-end">{{ (grandAmt - grandDisc) | number:'1.2-2' }}</td>
        <td class="text-end">{{ grandOpening | number:'1.2-2' }}</td>
        <td class="text-end">{{ grandOpening + (grandAmt - grandDisc) | number:'1.2-2' }}</td>
      </tr>

      <tr style="font-weight:bold; background-color:lightyellow">
        <td colspan="4" style="text-align:right;">एकूण:- सप्रेम-भेट-प्रति</td>
        <td class="text-end">{{ grandCW1 | number:'1.0-0' }}</td>
        <td class="text-end">{{ grandCW2 | number:'1.0-0' }}</td>
        <td class="text-end">{{ grandCW3 | number:'1.0-0' }}</td>
        <td class="text-end">{{ grandCW4 | number:'1.0-0' }}</td>
        <td class="text-end">{{ grandCW5 | number:'1.0-0' }}</td>
        <td class="text-end">{{ grandCCopies | number:'1.0-0' }}</td>
        <td class="text-end"></td>
        <td class="text-end"></td>
        <td class="text-end"></td>
        <td class="text-end"></td>
        <td class="text-end"></td>
      </tr>

    </table>
  </div>
</ng-container>


</div>
<div *ngIf="isLoading" class="main-loading">
    <span class="loader"></span>
    <p>Loading...</p>
</div>